module.exports = {
  endpointUrl: "https://mosobl.explo-it.ru/auth-back/",
  successUrl: "https://mosobl.explo-it.ru/",
    ldapOptions: {
      enableStrategy: false
    }
};
